import dayjs, { type Dayjs } from 'dayjs';

export const DATE_ISO_FORMAT = 'YYYY-MM-DD';

export const getDateDefault = (
  date: Date | Dayjs | string | undefined,
  format: string = 'DD.MM.YYYY'
): string => dayjs(date || dayjs()).format(format);

export const getFullTimestamp = (date: Date | string): string => dayjs(date).format('DD.MM.YYYY HH:mm:ss');
